import { PlatformLocation } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, Input, ViewChild, NgZone, Inject, Optional } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CandidateEditDialogComponent } from '../candidate-edit-dialog/candidate-edit-dialog.component';
import { CreateProcessListDialogComponent } from '../create-process-list-dialog/create-process-list-dialog.component';
import { FilterDialogComponent } from '../filter-dialog/filter-dialog.component';
import * as moment from 'moment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchDialogComponent } from '../search-dialog/search-dialog.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-recruiter-search',
  templateUrl: './recruiter-search.component.html',
  styleUrls: ['./recruiter-search.component.scss'],
})
export class RecruiterSearchComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['firstname', 'gender', 'state', 'city', 'district', 'score', 'resume', 'options'];
  columnsStyle = {
    firstname: { width: '20%' },
    gender: { width: '10%' },
    state: { width: '15%' },
    city: { width: '15%' },
    district: { width: 'auto' },
    desiredJobTitle: { width: 'auto' },
    resume: { width: 'auto' },
    score: { width: 'auto' },
    options: { width: '2%' }
  }
  columnsDisplayName = {
    firstname: 'Nome',
    gender: 'Gênero',
    state: 'Estado',
    city: 'Cidade',
    score: 'Pontuação',
    district: 'Bairro'
  }
  filterParams: any = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  submiting: boolean = false;
  processListLength: number = 0;
  candidatesRejected: number = 0;
  @Input('currentProcessListId') currentProcessListId: string;
  @Input('processStatus') processStatus: string;
  selectedIds: Array<any> = [];
  candidatesRejectedLength: number = 0
  filterDisplayName = {
    branch: 'setor',
    city: 'cidade',
    educationLevel: 'nivel de educação',
    gender: 'gênero',
    jobDescription: 'descrição do cargo',
    roleLevel: 'nivel da carreira',
    specializationName: 'cargo desejado',
    stateInitials: "estado",
    vacancy: 'área de atuação'
  }
  currentTooltip: any;
  filterForm: UntypedFormGroup;
  ProcessID: any;
  currentUser: any;
  submitingCandidates: boolean = false;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    public processList: ProcessListService,
    private pLocation: PlatformLocation,
    private snackbar: MatSnackBar,
    private change: ChangeDetectorRef,
    private zone: NgZone,
    fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) info: any,
  ) {
    this.filterForm = fb.group({
      keyword: [null, Validators.required],
      byColumn: [null]
    })
    if (info && info.processID) {
      this.ProcessID = info.processID;
      this.processStatus = info.processStatus;
    } else {
      this.ProcessID = '';
    }
  }

  ngOnInit(): void {

    // let subject = new Subject();
    // subject.subscribe(
    //   (result: any) => {

    //     const { trigger, scope } = result;
    //     this.submiting = trigger === 'pre';
    //     console.log('SUB', this.submiting);

    //   }
    // );

    this.currentUser = JSON.parse(localStorage.getItem('token'));
    // this.http.setLoadingIndicator(subject, 'process_list:lead');

    if (this.currentProcessListId == undefined && this.ProcessID !== '') {
      this.currentProcessListId = this.ProcessID;
    }

    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.paginator = this.paginator;

    const filterStorage = `filter:${this.currentProcessListId}`;

    if (localStorage.getItem(filterStorage)) {

      this.filterParams = JSON.parse(localStorage.getItem(filterStorage));
      this.getCandidates(0, 20, { searchs: JSON.stringify(this.filterParams) });
      this.getTotalCandidates({ searchs: JSON.stringify(this.filterParams) });

    }

    this.processListLength = this.processList.get(this.currentProcessListId) ? this.processList.get(this.currentProcessListId).length : 0;
    this.processList.getEvent()
      .subscribe(() => {
        this.processListLength = this.processList.get(this.currentProcessListId) ? this.processList.get(this.currentProcessListId).length : 0;
        this.candidatesRejectedLength = this.processList.rejectedsLength(this.currentProcessListId);
      });

    this.candidatesRejectedLength = this.processList.rejectedsLength(this.currentProcessListId);

    if (this.processStatus === 'finished') {
      setInterval(() => {
        this.dataSource.data = [];
      }, 500);
    }

  }

  clearRejectCandidates() {

    if (!confirm('Deseja realmente limpar a lista de candidatos rejeitados'))
      return;

    this.processList.clearRejectCandidates(this.currentProcessListId);
    this.snackbar.open('Lista de candidatos rejeitados limpa', 'OK', { duration: 3000 });

  }

  openProcessList() {

    const leads = this.processList.get(this.currentProcessListId).map(item => ({ id: item.id, score: item.score, keywords: item.keywords }));
    const payload: any = {
      leads: JSON.stringify(leads),
      processList: this.currentProcessListId,
      keywords: [...this.filterParams['jobDescription']]
    }

    if (this.filterForm.valid)
      payload.keywords.push(this.filterForm.get('keyword').value);

    this.submitingCandidates = true;
    this.http.save('process_list:lead', payload)
      .subscribe(
        (result: any) => {
          this.submitingCandidates = false;
          if (result.type === 'OK') {
            const leadsIds = this.processList.get(this.currentProcessListId).map(item => item.id);
            const params = {
              leads: JSON.stringify(leadsIds),
              processList: this.currentProcessListId,
              action: 'selected'
            }

            this.http.save('process_list_action', params)
              .subscribe({
                error: err => this.errorReport.showMessage(err)
              })
            this.snackbar.open('Recalculando pontuação dos candidatos', 'OK', { duration: 3000 });
            this.http.save('process_list:recalculate_keywords_score', { processList: this.currentProcessListId })
              .subscribe({
                next: () => {
                  this.snackbar.open('Pontuação recalculada com sucesso', 'OK', { duration: 3000 });
                  this.processList.getEvent().emit('save');
                },
                error: (err) => this.errorReport.showMessage(err)
              });

            this.processList.clear(this.currentProcessListId);
            this.processList.getEvent().emit('save');

          }
        },
        err => {
          this.errorReport.showMessage(err)
          this.submitingCandidates = false;
        }
      )

  }


  private openProcessListDialog() {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processList: {
          id: this.currentProcessListId,
          status: 'pending'
        }

      }
    }
    this.dialog.open(CreateProcessListDialogComponent, options)
      .afterClosed()
      .subscribe(
        (result) => {
          if (!result)
            this.pLocation.back()
        }
      )

  }

  openFilterDialog() {

    const options = {
      width: '800px',
      data: {
        filter: this.filterParams
      }
    }
    this.dialog.open(FilterDialogComponent, options)
      .afterClosed()
      .subscribe(
        (result) => {
          this.filterForm.reset();
          if (result) {

            if (Object.keys(result).length === 0)
              return;

            result['stateInitials'] = '';
            result['stateName'] = '';

            if (result.state) {
              result['stateInitials'] = result.state.sigla;
              result['stateName'] = result.state.nome;
            }

            delete result.state;
            this.filterParams = result;
            this.paginator.pageIndex = 0;
            const { pageIndex, pageSize } = this.paginator;
            localStorage.setItem(`filter:${this.currentProcessListId}`, JSON.stringify(this.filterParams));

            this.getCandidates(pageIndex, pageSize, { searchs: JSON.stringify(this.filterParams) })
            this.getTotalCandidates({ searchs: JSON.stringify(this.filterParams) });

          }
        }
      );

  }

  getCandidates(page = 0, limit = 20, params = {}) {

    this.submiting = true;
    this.filterForm.disable({ emitEvent: false })
    this.http.list('candidates', { ...params, page, limit })
      .subscribe(
        (results: any) => {
          this.dataSource.data = []
          if (results) {

            let data = [];
            for (let result of results) {

              const tooltip$ = this.getTooltip(result);

              data.push({
                tooltip$,
                id: result.id,
                firstname: result.firstname + ' ' + result.lastname,
                gender: result.gender,
                state: result.state,
                city: result.city,
                district: result.district,
                desiredJobTitle: result.desired_job_title || result.desired_job_title2,
                score: result.score ? parseInt(result.score) : 0
              });

            }

            if (data[0].score > 0 && !this.filterParams['orderBy'])
              this.filterParams['orderBy'] = { score: 'desc' };

            const candidatesId = results.map(candidate => candidate.id);

            this.dataSource.data = data;
            this.http.save('process_list_action', {
              leads: candidatesId,
              processList: this.currentProcessListId,
              action: 'searched'
            }).subscribe({
              error: err => this.errorReport.showMessage(err)
            })

          }

          this.submiting = false;
          this.filterForm.enable({ emitEvent: false })

        },
        err => this.errorReport.showMessage(err)
      )

  }

  getTooltip(row) {

    const options = {
      id: row.id,
      all: true
    }

    return this.http.get('experience', options)
      .pipe(
        map((result: any) => {

          const { data } = result;

          const tooltip = data.map(item => {
            const { init_date, final_date } = item;
            const finit_date = moment(init_date).format('DD/MM/Y');
            const ffinal_date = (final_date) ? moment(final_date).format('DD/MM/Y') : 'agora';
            return `${item.organization}, ${item.office || item.sinonimo} de ${finit_date} até ${ffinal_date}; `;
          })

          row.tooltip = tooltip;
          return tooltip;

        })
      );

  }

  clearFilters() {

    this.filterParams = {};
    this.dataSource.data = []
    localStorage.removeItem(`filter:${this.currentProcessListId}`);
    this.getTotalCandidates();
    this.filterForm.reset();

  }

  getTotalCandidates(params = {}) {

    this.http.get('candidates:total', params)
      .subscribe(
        (result: any) => {
          const { records } = result;

          this.paginator.length = records;
        },
        err => this.errorReport.showMessage(err)
      )

  }

  hasFilter() {
    return Object.keys(this.filterParams).length > 0;
  }

  getOrderBy(attr: string) {

    if (this.filterParams['orderBy'] && this.filterParams['orderBy'][attr]) {
      return this.filterParams['orderBy'][attr];
    }

    return false;

  }

  orderBy(attr: string, order: string) {

    if (this.submiting)
      return false;

    this.filterParams['orderBy'] = {
      [attr]: order
    };
    const { pageIndex, pageSize } = this.paginator;

    this.getCandidates(pageIndex, pageSize, { searchs: JSON.stringify(this.filterParams) })

  }

  onPageChange(args: PageEvent) {

    const { pageIndex, pageSize } = this.paginator;
    let params = {
      searchs: JSON.stringify(this.filterParams)
    }

    if (this.filterForm.valid) {
      const data = this.filterForm.getRawValue()
      params = {
        ...params,
        ...Object.entries(data).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined)
            acc[key] = value;
          return acc;
        }, {})
      };
    }

    this.getCandidates(pageIndex, pageSize, params);

  }

  hasSelected(id: number) {
    return this.processList.hasCandidateSelected(id, this.currentProcessListId)
  }

  hasAllSelected() {
    const selectedIds = this.processList.get(this.currentProcessListId).map(item => item.id);
    return this.processList.get(this.currentProcessListId).length > 0 && this.dataSource.data.every(data => selectedIds.findIndex(selectedId => data.id == selectedId) > -1);
  }

  isIndetermiteSelected() {
    const selectedIds = this.processList.get(this.currentProcessListId).map(item => item.id);
    return this.processList.get(this.currentProcessListId).length < this.dataSource.data.length && this.dataSource.data.some(data => selectedIds.findIndex(selectedId => data.id == selectedId) > -1)

  }

  disabledCheckbox(id: number) {
    return this.processList.hasCandidateAlreadySelected(id, this.currentProcessListId);
  }

  setCurrentTooltip(observable) {

    observable
      .subscribe((tooltip: any) => this.currentTooltip = tooltip);

  }

  openCandidateInfo(row) {

    const keywordsSearch = {
      params: (this.filterParams as any).jobDescription,
      form: [this.filterForm.get('keyword').value]
    }

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        candidate: row,
        processListId: this.currentProcessListId,
        keywordsSearch
      }
    }
    this.dialog.open(CandidateEditDialogComponent, options);

  }

  selectChange(args: MatCheckboxChange) {

    const { checked, source: { value: candidate } } = args
    const index = this.processList.get(this.currentProcessListId).map(item => item.id).findIndex(_id => _id == (candidate as any).id);

    if (checked === false) {
      this.selectedIds.splice(index, 1);
      this.processList.remove(index, this.currentProcessListId);

    } else {

      this.processList.add(candidate, this.currentProcessListId)
      const id = (candidate as any).id;

      if (this.processList.hasCandidateRejected(id, this.currentProcessListId))
        this.processList.reject(id, this.currentProcessListId)

      this.http.save('process_list_action', {
        leads: [id],
        processList: this.currentProcessListId,
        action: 'viewed'
      }).subscribe()

    }

  }

  onSelectionAllChange(args: MatCheckboxChange) {

    const { checked } = args;
    const { data: candidates } = this.dataSource;
    this.selectedIds = (checked) ? candidates.map(candidate => candidate.id) : [];
    if (checked) {

      for (let candidate of candidates)
        this.processList.add(candidate, this.currentProcessListId);

      // const candidatesId = candidates.map(candidate => candidate.id);      

    } else {
      this.processList.clearCandidateToAdd(this.currentProcessListId);
    }

  }

  submitFilter() {

    if (this.filterForm.valid) {

      if (this.dataSource.data.length === 0) {
        this.snackbar.open('A tabela precisa estar preenchida para fazer esse filtro', 'OK', { duration: 3000 });
        return;
      }

      const data = this.filterForm.getRawValue();
      const { pageSize } = this.paginator;

      const params = {
        searchs: JSON.stringify(this.filterParams),
        ...Object.entries(data).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined)
            acc[key] = value;
          return acc;
        }, {})
      }
      this.paginator.pageIndex = 0;
      this.getCandidates(0, pageSize, params)
      this.getTotalCandidates(params);

    }

  }

  resetFilter() {

    const { pageSize } = this.paginator;
    const params = {
      searchs: JSON.stringify(this.filterParams)
    }
    this.filterForm.reset();
    this.getCandidates(0, pageSize, params)
    this.getTotalCandidates(params);
    // this.columnKeywordFilterCount = {
    //   firstname: 0,
    //   gender: 0,
    //   state: 0,
    //   city: 0,
    //   district: 0
    // }    

  }

  private openSearchDialog() {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processList: {
          id: this.currentProcessListId
        }
      }
    }
    this.dialog.open(SearchDialogComponent, options)
      .afterClosed()
      .subscribe(
        (result) => {
          if (!result)
            //this.pLocation.back()
            this.processList.clear(this.currentProcessListId);
          this.processList.getEvent().emit('save');
        }
      )

  }

}